import Layout from "../components/Layout";
import React, {useEffect, useRef, useState} from "react";
import {useSearchParams} from "react-router-dom";
import axios from "axios";
import {BASE_URL} from "../utils/commonUrl";
import BootstrapModal from "../components/BootstrapModal";
import {Field, Form, Formik} from "formik";
import TextField from "../components/TextField";
import FormSelect from "../components/FormSelect";
import {Calendar} from "primereact/calendar";
import {useSelector} from "react-redux";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import {Toast} from "primereact/toast";
import defaultUser from '../assets/images/user_default.png';

const EvaluationReport = () => {
    const primeToast = useRef(null)
    const [searchParams] = useSearchParams()
    const {user} = useSelector((state) => state.auth)
    const [masterData, setMasterData] = useState([])
    const [assessmentList, setAssessmentList] = useState([])
    const [competencyList, setCompetencyList] = useState([])
    const [skillAssessment, setSkillAssessment] = useState([])
    const [skillMatrixAssessment, setSkillMatrixAssessment] = useState([])
    const [overAllEvaluation, setOverAllEvaluation] = useState([])    
    
    useEffect(() => {

        if (searchParams.has("employeeId")) {
            //const employeeId = searchParams.get("employeeId");
            const employeeId = atob(searchParams.get("employeeId"));
            const quarterId=(searchParams.get("quarterId"));            
            GetMasterData(employeeId,quarterId);
            GetAssessmentList(employeeId,quarterId);
            GetCompetencyList(employeeId,quarterId);
            GetSkillAssessment(employeeId,quarterId);
            GetSkillMatrixAssessment(employeeId,quarterId);
            GetOverAllEvaluation(employeeId,quarterId);            
        }
        else{
          console.log("Home_2");
        }
    }, [])

    const GetMasterData = (employeeId,quarterId) =>{
      const data={registerId:employeeId,quarterId:quarterId};
        axios.post(BASE_URL+"/api/report/GetEvaluationMasterData/",JSON.stringify(data))
            .then(response=>{
                setMasterData(response.data)
                console.log(masterData);
            })
            .catch(console.log)
    }

    const GetAssessmentList = (employeeId,quarterId) => {
      const data={registerId:employeeId,quarterId:quarterId};
        axios.post(BASE_URL + "/api/report/GetEvaluationCoreValues/",JSON.stringify(data))
            .then(response => {
                setAssessmentList(response.data)
            })
            .catch(console.error)
    }

    const GetCompetencyList = (employeeId,quarterId) => {
      const data={registerId:employeeId,quarterId:quarterId};
        axios.post(BASE_URL + "/api/report/GetEvaluationCompetencyValues/",JSON.stringify(data))
            .then(response => {
                setCompetencyList(response.data)
            })
            .catch(e => {
                console.log(e)
            })
    }

    const GetSkillAssessment = (employeeId,quarterId) => {
      const data={registerId:employeeId,quarterId:quarterId};
        axios.post(BASE_URL + "/api/report/GetEvaluationSkillAssessment/",JSON.stringify(data))
            .then(response => {
                setSkillAssessment(response.data)
            })
            .catch(e => {
                console.log(e)
            })
    }

    const GetSkillMatrixAssessment = (employeeId,quarterId) => {
      const data={registerId:employeeId,quarterId:quarterId};
        axios.post(BASE_URL + "/api/report/GetEvaluationSkillMatrixAssessment/",JSON.stringify(data))
            .then(response => {
                setSkillMatrixAssessment(response.data)
            })
            .catch(e => {
                console.log(e)
            })
    }

    const GetOverAllEvaluation = (employeeId,quarterId) => {
      const data={registerId:employeeId,quarterId:quarterId};
        axios.post(BASE_URL + "/api/report/GetOverallEvaluation/",JSON.stringify(data))
            .then(response => {
                setOverAllEvaluation(response.data)
            })
            .catch(e => {
                console.log(e)
            })
    }

    const downloadReportData = () => {
      const _RegisterID = atob(searchParams.get("employeeId"));
      const quarterId=(searchParams.get("quarterId")); 
      window.open("https://apps.bitopibd.com/bimobapps/PMSReport/PerformanceEvaluationReport?SearchStr="+btoa("RegisterID=" + _RegisterID +"&QuarterID=" + quarterId));
        //window.open("https://apps.bitopibd.com/bimobapps/PMSReport/PerformanceEvaluationReport?SearchStr="+btoa("RegisterID=" + _RegisterID +"&QuarterID=" + user.quarterID));;
    }

    return (
        <Layout>            
            <div className="row"> 
              <div className="col-8">
                <table className="table">
                <tbody>
                            <tr>
                              <td style={{width:"100px"}}><b>Performance Assessment Quarter</b></td>
                              <td>{masterData.length!==0?masterData[0].quarterName:""}</td>                              
                          </tr>           
                          <tr>
                              <td style={{width:"100px"}}><b>Employee Code</b></td>
                              <td>{masterData.length !== 0 ? masterData[0].employeeCode : ""}</td>                        
                          </tr>
                          <tr>
                              <td style={{width:"100px"}}><b>Employee's Name</b></td>
                              <td>{masterData.length !== 0 ? masterData[0].employeeName : ""}</td>                        
                          </tr>
                          <tr>
                              <td style={{width:"100px"}}><b>Job Title</b></td>
                              <td>{masterData.length !== 0 ? masterData[0].designation : ""}</td>                        
                          </tr> 
                          <tr>
                              <td style={{width:"100px"}}><b>Department</b></td>
                              <td>{masterData.length !== 0 ? masterData[0].department : ""}</td>                        
                          </tr> 
                          <tr>
                              <td style={{width:"100px"}}><b>Reporting Supervisor's Name</b></td>
                              <td>{masterData.length !== 0 ? masterData[0].supervisorName : ""}</td>                        
                          </tr> 
                          <tr>
                              <td style={{width:"100px"}}><b>Supervisor's Job Title</b></td>
                              <td>{masterData.length !== 0 ? masterData[0].supervisorDesignation : ""}</td>                        
                          </tr> 
                      </tbody>
                  </table>
              </div>
                <div className="col-4">
                  <div className="d-flex justify-content-center">
                    <button className="btn btn-primary btn-sm float-end" id="btnDownloadData" onClick={downloadReportData}><i class="bi bi-arrow-down-circle"></i> Download Data</button>
                  </div>
                  <div className="d-flex justify-content-center">
                    
                    <img src={masterData.length !== 0 ? "data:image/png;base64,"+ masterData[0].empImage : defaultUser} width={180}
                      height={180}
                      style={{borderRadius:"50%"}}
                      alt="user profile" className=" m-1" />
                    
                  </div>                  
                </div>
              </div>

              <div className="row">
              <div class="card">
                <h5 class="card-header">Performance Assessment Score Card</h5>
                <div class="card-body">
                    <h5 class="card-title">Core Values</h5>
                
                <table className="table">
              <thead>                
                <tr>
                  <th scope="col" className="tdHeaderGroup">Full Score</th>
                  <th scope="col" className="tdHeaderGroup">RCL</th>
                  <th scope="col" className="tdHeaderGroup">Obtained Score</th>
                  <th scope="col" className="tdHeaderGroup">Improvement Areas</th>  
                  <th scope="col" className="tdHeaderGroup">Action/s</th>                
                </tr>
              </thead>
              <tbody>
                {assessmentList.map((value, index) => (
                  <tr key={index}>
                    <td className="tdCenter">{value.weight}</td>
                    <td className="tdWhiteSpace tdCenter">{value.rca}</td>                    
                    <td className="tdWhiteSpace tdCenter">{value.supervisorAssesmentMark}</td>
                    <td className="tdWhiteSpace">{value.assestmentTitleName}</td>
                    <td className="tdWhiteSpace tdCenter" style={{width:"500px"}}></td>
                  </tr>
                ))}                
              </tbody>
            </table>  
                </div>

           
                </div>
              </div>
              <div className="row">
              <div class="card">
                
                <div class="card-body">
                    <h5 class="card-title">Core Competencies</h5>
                
                <table className="table">
              <thead>                
                <tr>
                  <th scope="col" className="tdHeaderGroup">Full Score</th>
                  <th scope="col" className="tdHeaderGroup">RCL</th>
                  <th scope="col" className="tdHeaderGroup">Obtained Score</th>
                  <th scope="col" className="tdHeaderGroup">Improvement Areas</th>  
                  <th scope="col" className="tdHeaderGroup">Action/s</th>                
                </tr>
              </thead>
              <tbody>
                {competencyList.map((value, index) => (
                  <tr key={index}>
                    <td className="tdCenter">{value.weight}</td>
                    <td className="tdWhiteSpace tdCenter">{value.rca}</td>                    
                    <td className="tdWhiteSpace tdCenter">{value.supervisorCompetencyMark}</td>
                    <td className="tdWhiteSpace">{value.competencyName}</td>
                    <td className="tdWhiteSpace tdCenter" style={{width:"500px"}}></td>
                  </tr>
                ))}                
              </tbody>
            </table>  
                </div>
                </div>
              </div>
              <div className="row">
              <div class="card">
                
                <div class="card-body">
                    <h5 class="card-title">Skill Assessment</h5>
                
                <table className="table">
              <thead>                
                <tr>
                  <th scope="col" className="tdHeaderGroup">Full Score</th>
                  <th scope="col" className="tdHeaderGroup">Obtained Score</th>
                  <th scope="col" className="tdHeaderGroup">Improvement Areas</th>  
                  <th scope="col" className="tdHeaderGroup">Action/s</th>                
                </tr>
              </thead>
              <tbody>
                {skillAssessment.map((value, index) => (
                  <tr key={index}>
                    <td className="tdCenter verticalMiddle" style={{width:"10%"}}>{value.weight}</td>                  
                    <td className="tdWhiteSpace tdCenter verticalMiddle" style={{width:"12%"}}>{value.matrixMark}</td>
                    <td style={{width:"500px"}}>{value.matrixTitle}</td>
                    <td className="tdWhiteSpace tdCenter" style={{width:"25%"}}></td>
                  </tr>
                ))}                
              </tbody>
            </table>  
                </div>
                </div>
              </div>
              <div className="row">
              <div class="card">
                
                <div class="card-body">
                    <h5 class="card-title">Skill Will Matrix Assessment</h5>
                
                <table className="table">
              <thead>                
                <tr>
                  <th scope="col" className="tdHeaderGroup">Quadrant No</th>
                  <th scope="col" className="tdHeaderGroup">Quadrant Type</th>
                  <th scope="col" className="tdHeaderGroup">Quadrant Details</th>  
                  <th scope="col" className="tdHeaderGroup">Improvement Areas</th> 
                  <th scope="col" className="tdHeaderGroup">Action/s</th>                
                </tr>
              </thead>
              <tbody>
                {skillMatrixAssessment.map((value, index) => (
                  <tr key={index}>
                    <td className="tdCenter verticalMiddle" style={{width:"10%"}}>{value.quadrantNo}</td>                  
                    <td className="tdWhiteSpace tdCenter verticalMiddle" style={{width:"12%"}}>{value.quadrantType}</td>
                    <td className="tdWhiteSpace tdCenter verticalMiddle" style={{width:"15%"}}>{value.skillStatus}</td>
                    <td className="tdCenter verticalMiddle" style={{width:"35%"}}>{value.matrixTitle}</td>
                    <td className="tdWhiteSpace tdCenter" style={{width:"28%"}}></td>
                  </tr>
                ))}                
              </tbody>
            </table>  
                </div>
                </div>
              </div>
              <div className="row">
              <div class="card">
                
                <div class="card-body">
                    <h5 class="card-title">Overall Evaluation</h5>
                
                <table className="table">
              <thead>                
                <tr>
                  <th scope="col" className="tdHeaderGroup">Full Score</th>
                  <th scope="col" className="tdHeaderGroup">Total Mark</th>
                  <th scope="col" className="tdHeaderGroup">Obtained Score(%)</th>
                  <th scope="col" className="tdHeaderGroup">Improvement Areas</th>  
                  <th scope="col" className="tdHeaderGroup">Action/s</th>                
                </tr>
              </thead>
              <tbody>
                {overAllEvaluation.map((value, index) => (
                  <tr key={index}>
                    <td className="tdCenter">{value.totalScore}</td>                  
                    <td className="tdWhiteSpace tdCenter">{value.grandTotalMark}</td>
                    <td className="tdWhiteSpace tdCenter">{value.obtainedScorePercentage}</td>
                    <td className="tdWhiteSpace tdCenter" style={{width:"300px"}}></td>
                    <td className="tdWhiteSpace tdCenter" style={{width:"300px"}}></td>
                  </tr>
                ))}                
              </tbody>
            </table>  
                </div>
                </div>
              </div>
              <div className="row">
              <div class="card">
                
                <div class="card-body">
                    <h5 class="card-title">Reporting Suprvisor's Comment</h5>
                
                    <div className="mt-0" style={{border:"1px solid #000", height:"200px"}}>

                    </div>
                </div>
                </div>
              </div>
              <div className="row">
              <div class="card">
                
                <div class="card-body">                   
                    
                    <div className="row mt-2">
                        <div className="col-md-4" style={{borderTop:"1px solid #000"}}>
                            <center>Employee's Signature & Date</center>
                        </div>
                        <div className="col-md-4">
                            
                        </div>
                        <div className="col-md-4" style={{borderTop:"1px solid #000"}}>
                            <center>Reporting Supervisor's Signature & Date</center>
                        </div>
                    </div>
                    
                </div>
                </div>
              </div>
        </Layout>
    )
}

export default EvaluationReport